"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Upload, {
    defaultFileList: [{
      uid: '3',
      name: 'zzz.png',
      status: 'error',
      response: 'Server Error 500',
      url: 'http://www.baidu.com/zzz.png'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UploadOutlined, null)
  }, "Upload")), /*#__PURE__*/_react.default.createElement(_antd.Upload, {
    listType: 'picture',
    defaultFileList: [{
      uid: '3',
      name: 'zzz.png',
      status: 'error',
      response: 'Server Error 500'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UploadOutlined, null)
  }, "Upload")));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorError', 'colorErrorBg'],
  key: 'danger'
};
var _default = exports.default = componentDemo;